(function () {
  if (window.NRHome) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function announcement(root) {
    var bar = root.querySelector('[data-nr-ab]');
    if (!bar || bar.__nr) return; bar.__nr = true;
    var ms = bar.querySelectorAll('[data-nr-msg]'), i = 0, paused = false;
    if (ms.length < 2 || reduce) return;
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    var speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
    bar.__iv = setInterval(function () {
      if (paused) return;
      ms[i].classList.remove('on'); i = (i + 1) % ms.length; ms[i].classList.add('on');
    }, speed);
  }

  function menu(root) {
    var b = root.querySelector('[data-nr-burger]'), nv = root.querySelector('[data-nr-nav]');
    if (!b || !nv || b.__nr) return; b.__nr = true;
    function close() { nv.classList.remove('open'); b.setAttribute('aria-expanded', 'false'); }
    b.addEventListener('click', function (e) { e.stopPropagation(); var o = nv.classList.toggle('open'); b.setAttribute('aria-expanded', o); });
    document.addEventListener('click', function (e) { if (nv.classList.contains('open') && !nv.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    nv.addEventListener('click', function (e) { if (e.target.tagName === 'A') close(); });
  }

  /* {dias} en un texto con fecha de fin: «Quedan 5 días», «Últimos días», «Termina mañana» o «Solo hoy» (días reales en hora de Madrid) */
  function daysLeft(end) {
    var f = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Madrid' });
    return Math.round((Date.parse(f.format(new Date(end - 1))) - Date.parse(f.format(new Date()))) / 864e5);
  }
  function countdown(el, end) {
    var t = el.querySelector('a') || el;
    if (!t.__nrTpl) t.__nrTpl = t.textContent;
    if (t.__nrTpl.indexOf('{dias}') < 0) return;
    var d = daysLeft(end), w = d > 3 ? 'Quedan ' + d + ' días' : d > 1 ? 'Últimos días: quedan ' + d : d === 1 ? 'Termina mañana' : 'Solo hoy';
    var parts = t.__nrTpl.split('{dias}'); t.textContent = '';
    parts.forEach(function (p, i) { if (i) { var b = document.createElement('b'); b.textContent = w; t.appendChild(b); } t.appendChild(document.createTextNode(p)); });
  }

  /* Ofertas con fecha de fin: al pasar la fecha se ocultan precios rebajados y textos de oferta */
  function offers(root) {
    root.querySelectorAll('[data-nr-ends]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-nr-ends'));
      if (isNaN(end)) return;
      if (Date.now() < end) { countdown(el, end); return; }
      el.classList.add('ended');
      var alt = el.getAttribute('data-nr-ended-text');
      if (alt) el.textContent = alt;
      if (el.hasAttribute('data-nr-hide-ended')) el.style.display = 'none';
    });
  }

  function footer(root) {
    if (window.matchMedia('(min-width:900px)').matches) root.querySelectorAll('.ft details').forEach(function (d) { d.open = true; });
  }

  function init(root) { root = root || document; announcement(root); menu(root); offers(root); footer(root); }

  window.NRHome = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
